var Frontend = Frontend || {};

Frontend.searchFired       = false;
Frontend.searchMobileFired = false;

Frontend.searchTimer       = function () {
};
Frontend.searchMobileTimer = function () {
};

Frontend.searchUrl       = Frontend.searchUrl || '';
Frontend.searchMobileUrl = Frontend.searchMobileUrl || '';

Frontend.options             = {
  productAjaxAttribute:      'ajax-append',
  productListSnippetName:    'snippet-productList-productList-list-container',
  productListHolderSelector: '.product-list',
  variantFormSelector:       '#variant-form',
  variantSelectSelector:     '#variant-id',

  searchFormSelector:       '#search',
  searchMobileFormSelector: '#search-mobile',

  searchInputSelector:       '#search-input',
  searchMobileInputSelector: '#search-mobile-input',

  searchSubmitButtonId:       '#search-submit-button',
  searchMobileSubmitButtonId: '#search-mobile-submit-button',

  searchDelay:       500,
  searchMobileDelay: 500,

  addProductFormSelector: '#add-product-form',
  targetModalSelector:    'target-modal'
};
Frontend.pagination          = false;
Frontend.appendProductsFired = false;
Frontend.targetModal         = null;
Frontend.showParameters = false;

//inicializace pro loading pri kliku na rezervovat tlacitko
reservedBtnLoading();

// konfigurator - change selectbox
$(document).on('change', 'select.js-select-configurator', function (e) {
    var productHolder = $('#snippet-productList-productList-list-container');
    loaderActive(productHolder);
    $('input[name="changedSelect"]').val($(this).data('id') + '-' + $(this).val());
    $(this).closest("form").submit();
});

function initRentalDatePickers(dateTimeHighlights) {
  // pole dateTimeHighlights se definuje v detail.latte (Product)
  // console.log(dateTimeHighlights);

  jQuery('#date_timepicker_start_icon').click(function(){
    jQuery('#date_timepicker_start').datetimepicker('show');
  });
  jQuery('#date_timepicker_end_icon').click(function(){
    jQuery('#date_timepicker_end').datetimepicker('show');
  });

//datetime picker
  $.datetimepicker.setLocale('cs');
  var $minStartDate = jQuery('#date_timepicker_start').data('min-date');
  //rozmezi od - do
  jQuery('#date_timepicker_start').datetimepicker({
    format: 'j.n.Y H:i',
    formatTime: 'H:i',
    formatDate: 'j.n.Y',
    dayOfWeekStart: 1,
    disabledWeekDays: [6,0],
    minTime:'8:00',
    maxTime:'18:00',
    minDate: $minStartDate,
    highlightedPeriods: dateTimeHighlights,
    onChangeDateTime: function(ct){
      //prevod casu do spravneho formatu se kterym umi pracovat moment.js
      var $startDate = jQuery('#date_timepicker_start').val();
      var $startDateRes = changeDateFormat($startDate);
      //prevod casu do unix timestamp aby se dal cas porovnavat
      var $timeStampStart = ( moment($startDateRes).unix() );

      //prevod casu do spravneho formatu se kterym umi pracovat moment.js
      var $endDate = jQuery('#date_timepicker_end').val();
      var $endDateRes = changeDateFormat($endDate);
      //prevod casu do unix timestamp aby se dal cas porovnavat
      var $timeStampEnd = ( moment($endDateRes).unix() );

      // console.log($startDateRes);
      // console.log($endDateRes);
      // console.log($timeStampStart);
      // console.log($timeStampEnd);

      //pokud je termin od vetsi nez termin do, tak termin do nastav na termin od
      if($timeStampStart > $timeStampEnd){
        jQuery('#date_timepicker_end').val(jQuery('#date_timepicker_start').val());
      }
    }
    // onShow: function (ct) {
    //   this.setOptions({
    //     maxDate: jQuery('#date_timepicker_end').val() ? jQuery('#date_timepicker_end').val() : false
    //   })
    // }
  });
  jQuery('#date_timepicker_end').datetimepicker({
    format: 'j.n.Y H:i',
    formatTime: 'H:i',
    formatDate: 'j.n.Y',
    dayOfWeekStart: 1,
    disabledWeekDays: [6,0],
    minTime:'8:00',
    maxTime:'18:00',
    highlightedPeriods: dateTimeHighlights,
    onShow: function (ct) {
      this.setOptions({
        minDate: jQuery('#date_timepicker_start').val() ? jQuery('#date_timepicker_start').val() : false
      })
    }
  });
}

function changeDateFormat($insertedDate){
  //prevadi format j.n.Y H:i na Y-n-j H:i
  var $res = $insertedDate.split(" ");
  // console.log($res);
  var $dates = $res[0];
  var $times = $res[1];
  var $resDates = $dates.split(".");
  var $year = $resDates[2];
  var $month = $resDates[1];
  var $day = $resDates[0];
  var $newDate = $year + "-" + $month + "-" + $day + " " + $times;
  // console.log($newDate);
  return $newDate;
}

$(document).ready(function () {

  $( ".js-category-link, .category-item-submenu-box" ).hover(
      function() {
        $( this ).closest( ".js-accordion-item" ).addClass('hover');
      }, function() {
        $( this ).closest( ".js-accordion-item" ).removeClass('hover');
      }
  );

  $(document).on('click', '.js-show-hide-toggle', function (event) {
    var altText = $(this).data('alt-text');
    var htmlText = $(this).text();

    //swap texts
    $(this).data('alt-text', htmlText);
    $(this).html(altText);

    // $(this).closest('.js-show-hide-wrapper').find('.js-show-hide-hidden').slideToggle();
    $(this).closest('.js-show-hide-wrapper').toggleClass('open');
  });

  //initialize hide alernative products
  $(".js-variants-wrapper").find('.js-variant-item-show-hide').hide();
  //toggle show hide alternative products
  $(document).on('click', '.js-variants-toggle', function(){

    var altText = $(this).data('alt-text');
    var htmlText = $(this).text();

    //swap texts
    $(this).data('alt-text', htmlText);
    $(this).html(altText);

    $(this).closest('.js-variants-wrapper').find('.js-variant-item-show-hide').slideToggle();
  });

  //show/hide header banners
  if (!!$.cookie('banner-header-text')) {
    // have cookie
  } else {
    // no cookie
    $('.js-banner-header-block-text').addClass('show');
  }
  $('.js-banner-header-close-text').click( function (event) {
    event.preventDefault();
    $(this).closest('.js-banner-header-block-text').removeClass('show');
    createCookie('banner-header-text', 'true', 1);
  });
  if (!!$.cookie('banner-header-image')) {
    // have cookie
  } else {
    // no cookie
    $('.js-banner-header-block-image').addClass('show');
  }
  $('.js-banner-header-close-image').click( function (event) {
    event.preventDefault();
    $(this).closest('.js-banner-header-block-image').removeClass('show');
    createCookie('banner-header-image', 'true', 1);
  });

  $(document).on('hidden.bs.modal', '#loginModal', function (e) {
    var dataElement = e.target.querySelectorAll('[data-close-redirect]');

    if (!dataElement.length) {
      return;
    }

    var link = dataElement[0].dataset.closeRedirect;

    if (!link) {
      return;
    }

    window.location.href = link;
  });

  $('.skeleton').hide();
  $('.js-skeleton-load').css({
    'opacity': '1'
  });

  if($("#spin-01").length) {
    $("#spin-01").spritespin({
      // path to the source images.
      source: spinsource01,
      responsive: true,
      frameTime: 40,
      animate: true,
      // retainAnimate: true,
      plugins: [
        'progress',
        '360',
        'drag'
      ]
    });
  }

  //float menu
  $(document).on('click', '.js-flm-toggle', function(event){
    $(this).closest('.flm-menu').toggleClass('open');
  });
  $(document).on('mouseenter', '.js-flma', function(event){
    $(this).addClass('active');
  });
  $(document).on('mouseleave', '.js-flma', function(event){
    $(this).removeClass('active');
  });

//  $("select.js-select-configurator").on("change", function () {
//    $(this).closest("form").submit();
//  });

  //    $('#frm-form-phone').mask('+000 000 000 000');
//    $('#frm-form-billingStreetNo').mask('0#');
//    $('#frm-form-billingZip').mask('000 00')

  $(document).on('click', '.js-detail-buy-button', function(){
    $(this).addClass('loading');
  });

  //contact
  $(document).on('click', '.js-contact-secondary-toggle', function(){
    $(this).closest('.js-contact-secondary-wrapper').toggleClass('open');
  });

  //faq open/close
  $(document).on('click', '.faq-box', function(){
    $(this).toggleClass('open');
  });

  $('.sidebar').stickySidebar({
    topSpacing: 20,
    bottomSpacing: 20
  });

  var $viewSlider = $('.js-view-slider-range')
  $viewSlider.ionRangeSlider({
    min: 0,
    max: 1,
    from: 0
  });

  $viewSlider.on('change', function(){
    var $this = $(this);
    var $from = $this.data("from");

    if($from == 0){
      $('.js-product-list-parameters').removeClass('show');
      Frontend.showParameters = false;
    }
    else if($from == 1){
      $('.js-product-list-parameters').addClass('show');
      Frontend.showParameters = true;
    }
  });

  var $viewSliderData = $viewSlider.data("ionRangeSlider");
  $('.js-view-irs-right').on('click', function () {
    $viewSliderData.update({
      from: 1
    });
  });
  $('.js-view-irs-left').on('click', function () {
    $viewSliderData.update({
      from: 0
    });
  });

  var $currencSlider = $('.js-currency-slider-range')
  $currencSlider.ionRangeSlider({
    values: [
      "CZK", "EUR"
    ],
    min: 0,
    max: 1,
    from: 0
  });

  $currencSlider.on('change', function(){
    var $this = $(this);
    var $link = $this.data("href");
    // console.log($link);
    window.location.href = $link;
  });

  var $currencySliderData = $(".js-currency-slider-range").data("ionRangeSlider");
  $('.js-irs-right').on('click', function () {
    $currencySliderData.update({
      from: 1
    });
  });
  $('.js-irs-left').on('click', function () {
    $currencySliderData.update({
      from: 0
    });
  });

  initRentalDatePickers(dateTimeHighlights);

  $('.js-datetimepicker').datetimepicker({
    format:'d.m.Y H:i',
    formatTime:'H:i',
    formatDate:'d.m.Y'
  });

  //datepicker
  $('.js-datepicker').each(function() {
    $(this).datepicker({
      uiLibrary: 'bootstrap4',
      weekStartDay: 1,
      format: 'd.m.yyyy',
      locale: 'cs-cs',
      icons:{
        rightIcon: '<i class="far fa-calendar-alt"></i>'
      }
    })
  });
  // $('.js-datepicker').datepicker({
  //   uiLibrary: 'bootstrap4',
  //   weekStartDay: 1,
  //   format: 'd.m.yyyy',
  //   locale: 'cs-cs',
  //   icons:{
  //     rightIcon: '<i class="far fa-calendar-alt"></i>'
  //   }
  // });

  $('input:radio[name="parameter-switcher"]').change(function(){
    if($(this).val() == 'on'){
      // console.log("On");
      $('.js-product-list-parameters').addClass('show');
      Frontend.showParameters = true;
    }
    else if($(this).val() == 'off'){
      // console.log("Off");
      $('.js-product-list-parameters').removeClass('show');
      Frontend.showParameters = false;
    }
  });

    //cart voucher show/hide
    $(document).on('click', '.js-radiobox-label', function(event){
      event.preventDefault();
      $(this).closest('.checkbox-group').find('.js-radiobox-block').removeClass('active');
      var $radioBlock = $(this).closest('.js-radiobox-block');
      $radioBlock.find('input[type=radio]').trigger('click');
      $radioBlock.addClass('active');
    });
    //cart voucher show/hide
    $(document).on('change', '.js-voucher-checkbox', function(){
        var $voucherWrapper = $(this).closest('.js-voucher-wrapper');
        var $voucherContent = $voucherWrapper.find('.js-voucher-content');

        $voucherContent.toggleClass('open');
    });

    //image lazy load init
    initLazyLoad();
    fn_advantage_slider();
    fn_category_slider();

    //coordinates in image in percentage
  $('.js-click-test').on('click', function(e){
    var offset = $(this).offset();
    var xCoordinate = (e.pageX - offset.left) / $(this).outerWidth() * 100;
    var yCoordinate = (e.pageY - offset.top) / $(this).outerHeight() * 100;
    // console.log('X: ' + xCoordinate + ' | Y: ' + yCoordinate);
  });

  //animate scroll
  $(".js-animate-scroll").click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
  });
  
  // nascrolluj na prvek s id = "#js-form-scroll-here" (pokud existuje)
  if($("#js-form-scroll-here").length) {
    $('html,body').animate({scrollTop: $("#js-form-scroll-here").offset().top - 20},'slow');  
  }

  //$('.js-mask-phone').mask('+000 000 000 000');
  //menu on click
  $(document).on('click', '.js-category-submenu-trigger', function(event){
    event.preventDefault();
    var menuWrapper = $(this).closest('.js-menu-dropdown');
    if(menuWrapper.hasClass('open')){
      menuWrapper.removeClass('open');
    }
    else{
      $('.js-menu-dropdown').removeClass('open');
      menuWrapper.addClass('open');
    }
  });
  //menu on hover
  /*
  $(document).on('mouseenter', '.js-category-submenu-trigger', function(event){
      var $this = $(this);
      $this.delay(250).queue(function(next){
          $('.js-menu-dropdown').removeClass('open');
          $this.closest('.js-menu-dropdown').addClass('open');
          $('.js-main').addClass('open-menu');
          next();
      });
  });
  $(document).on('mouseleave', '.js-menu-dropdown', function(event){
       $('.js-category-submenu-trigger').clearQueue();
       $(this).removeClass('open');
       $('.js-main').removeClass('open-menu');
  });
  */
  $(document).on('touchstart', '.js-category-submenu-trigger', function(event){
      event.preventDefault();
  });
  $(document).on('touchend', '.js-category-submenu-trigger', function(event){
    event.preventDefault();
    var menuWrapper = $(this).closest('.js-menu-dropdown');
    if(menuWrapper.hasClass('open')){
        menuWrapper.removeClass('open');
    }
    else{
        $('.js-menu-dropdown').removeClass('open');
        menuWrapper.addClass('open');
    }
  });

  var timeout = null;

  $('.js-email-validated').on('change input', function (e) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
        $.ajax({
          url: '/api/validate/email',
          data: {
            'email': $(e.target).val()
          },
          method: 'GET',
          success: function (data) {
            var validator = $('.js-span-validation-email');

            if (data.valid) {
              validator.addClass('form-icon').removeClass('fail').addClass('success');
            } else {
              validator.addClass('form-icon').removeClass('success').addClass('fail');
            }
          }
        })}, 250);
  });

  $('.js-mask-phone').on('input change', function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      $.ajax({
        url: '/api/validate/phone',
        data: {
          'phone': $('.js-mask-phone').val()
        },
        method: 'GET',
        success: function (data) {
          var validator = $('.js-span-validation-phone');

          if (data.valid) {
            validator.addClass('form-icon').removeClass('fail').addClass('success');
          } else {
            validator.addClass('form-icon').removeClass('success').addClass('fail');
          }
        }
      })}, 250);
  });

  $('.js-mask-phone').mask('PYYY 000 000 000', {
    translation: {
      'P': {
        pattern: /\+/, optional: true
      },
      'Y': {
        pattern: /[0-9]/, optional: true
      }
    }
  });

  if ($('.js-gallery-item-trigger').length) {
    $('.js-gallery-item-trigger').on('click', function () {
      var $index = $(this).data('slick-index');
      $('.detail-gallery-main [data-slick-index=' + $index + ']').trigger('click');
    });
  }
  $('.js-mask-zip').mask('000 00', {
    onChange: function (c) {
      // console.log(c.target);
      var validator = $(c.target + '.js-span-validation');

      if (c.length === 6) {
        validator.addClass('form-icon').removeClass('fail').addClass('success');
      } else {
        validator.addClass('form-icon').removeClass('success').addClass('fail');
      }
    },
  });
});

$(function () {
  $.nette.init();

  Frontend.initSelect2();
  Frontend.initSelect2_variants();
  Frontend.initSelect2_configurator();

  fn_components_offer_calculation_orbinet();

  $.nette.ext('frontendAjaxExtension', {
    before:  Frontend.beforeAjaxExtensionHandler,
    success: Frontend.successAjaxExtensionHandler
  });

  //initialize instafeed
  if ($("#instagramfeed").length) {
    instagramFeed.run();
  }

    $('.js-search-trigger').click(function () {
        // if ($(window).width() < 850) {
        $('.js-search-form').toggleClass('open');
        $('.js-search-input').focus();
        // }
    });

    $(document).click(function (event) {
        if (($(".js-search-form").length > 0) && ($(".js-search-form").hasClass("open"))) {
            if (!$(event.target).closest(".header-middle .js-search-form").length) {
                $(".header-middle .js-search-form").toggleClass("open");
            }
        }
        if (($(".js-menu-dropdown").length > 0) && ($(".js-menu-dropdown").hasClass("open"))) {
            if (!$(event.target).closest(".menu-item .js-menu-dropdown").length) {
                $(".menu-item .js-menu-dropdown").removeClass("open");
            }
        }
    });

    $('.js-category-headline').on('click', function (event) {
        $(this).toggleClass('open');
        $(this).closest('.js-accordion-wrapper').find('.js-category-content').toggleClass('open');
    });

  //scroll top
  $('.js-back-top').on('click', function () {
    var body = $("html, body");
    body.stop().animate({scrollTop: 0}, 500, 'swing', function () {

    });
  });

  var partners = $('.js-partners-slider');
  partners.owlCarousel({
    items:              6,
    loop:               true,
    autoplay:           true,
    lazyLoad:           true,
    autoplayTimeout:    2000,
    autoplayHoverPause: true,
    nav:                true,
    dots:               false,
    navText:            ["<span class='partnersSliderLeft'></span>", "<span class='partnersSliderRight'></span>"],
    responsive:         {
      // breakpoint from 0 up
      0:   {
        items: 1
      },
      // breakpoint from 480 up
      480: {
        items: 2
      },

      // breakpoint from 600 up
      600:  {
        items: 3
      },
      // breakpoint from 800 up
      800:  {
        items: 4
      },
      // breakpoint from 960 up
      960:  {
        items: 5
      },
      // breakpoint from 960 up
      1024: {
        items: 6
      }
    }
  });

  // show/hide search input
  // $('.js-search-btn').click(function (event) {
  //     var searchInput = $('.js-search-input');
  //
  //     if(!searchInput.hasClass('open')) {
  //         event.preventDefault();
  //         if ($(window).width() < 850) {
  //             searchInput.toggleClass('open');
  //             searchInput.focus();
  //         }
  //         event.stopPropagation();
  //     }
  // });
  // onclick to hide search form
  // $(document).click(function (event) {
  //     if (($(".js-search-form").length > 0) && ($(".js-search-input").hasClass("open"))) {
  //         if (!$(event.target).closest(".header-middle-wrapper .js-search-form").length) {
  //             if ($(window).width() < 850) {
  //                 $(".header-middle-wrapper .js-search-input").toggleClass("open");
  //             }
  //         }
  //     }
  // });

  //dropdown button
  $('.js-dropdown button').on('click', function () {
    $(this).closest('.js-dropdown').toggleClass('open');
  });

  //dropdown hover
  dropdownMenuHover();
  $(window).resize(function () {
    dropdownMenuHover();
  });

  //captcha show/hide
  $(document).on('focus', '.js-newsletter input', function () {
    var captchaWrapper = $(this).closest('.js-newsletter-wrapper').find('.js-newsletter-captcha-wrapper');
    captchaWrapper.slideDown();
  });

  $(document).on('click', '.js-subcategory-toggle', function (event) {
    event.preventDefault();
    $(this).closest('.js-subcategory-wrapper').toggleClass('open');
  });
  $(document).on('click', '.js-bestseller-toggle', function (event) {
    event.preventDefault();
    $(this).closest('.js-bestseller-wrapper').toggleClass('open');
  });
  $(document).on('click', '.js-accessories-toggle', function (event) {
    event.preventDefault();
    $(this).closest('.js-accesories-wrapper').toggleClass('open');
  });

  $('body').on('click', '[data-toggle="modal"]', function () {
    target = $(this).data('target');
    $(target).find('.js-modal-wrapper').html('<div id="processed"><div class="spinner">\n' +
      '  <div class="bounce1"></div>\n' +
      '  <div class="bounce2"></div>\n' +
      '  <div class="bounce3"></div>\n' +
      '</div></div>')
    $.nette.ajax($(this).attr('href'));
  });

  //objednavky toggle
  $(document).on('click', '.js-order-toggle', function () {
    $(this).closest('.order-item').toggleClass('closed');
  });


  var blog = $('.blog-slideshow');
  blog.owlCarousel({
    margin:     14,
    nav:        false,
    responsive: {
      0:    {
        items: 1
      },
      567:  {
        items: 2
      },
      870:  {
        items: 3
      },
      1170: {
        items: 4
      },
      1280: {
        items: 5
      }

    }
  });
  $('.blog-wrapper .left').click(function () {
    blog.trigger('prev.owl.carousel');
  });
  $('.blog-wrapper .right').click(function () {
    blog.trigger('next.owl.carousel');
  });

  $("body").on("click", '.js-count .js-plus,.js-number .js-plus', function () {
    var val    = parseInt($(this).siblings("input").val());
    var soucet = val + 1;
    $(this).siblings("input").val(soucet);
    // console.log(soucet);

    $(this).closest("form").submit();

  });

  $("body").on('click', '.js-count .js-minus,.js-number .js-minus', function () {
    var val = parseInt($(this).siblings("input").val());

    var soucet = val - 1;

    if (soucet <= 0) {
      soucet = 1;
    }

    $(this).siblings("input").val(soucet);
    // console.log(soucet);

    $(this).closest("form").submit();

  });

  $("body").on("change", ".js-item-quantity", function () {

    if ($(this).val() <= 0) {
      $(this).val(1);
    }

    $(this).closest("form").submit();
  });

  $(document).on('click', '.ajax-products', function (e) {
    e.preventDefault();

    var productHolder = $('[data-product-holder]');
    loaderActive(productHolder);

    Frontend.appendProductsFired = true;
    Frontend.pagination          = true;
    $('#' + Frontend.options.productListSnippetName).attr('data-' + Frontend.options.productAjaxAttribute, 'true');
    // $.nette.ajax($(this).attr('href'));
    $.nette.ajax({
      url:     $(this).attr('href'),
      success: function ($msg) {
        loaderClose(productHolder);
      }
    });
  });

  $(document).on('change', Frontend.options.variantFormSelector + ' select', function () {
    Frontend.changeVariantFormListener($(this));
  });

  // vyhledávání
  $(document).on('keyup', Frontend.options.searchInputSelector, Frontend.changeSearchInputListener);
  $(document).on('click', Frontend.options.searchSubmitButtonId, Frontend.clickSearchSubmitButtonListener);

  $(document).on('keyup', Frontend.options.searchMobileInputSelector, Frontend.changeSearchMobileInputListener);
  $(document).on('click', Frontend.options.searchMobileSubmitButtonId, Frontend.clickSearchMobileSubmitButtonListener);

  $('.search-form').on("mouseleave", function () {
    $('.js-search-dropdown').removeClass('active');
  });

  // hodnocení produktů
  var ratingValue = null;
  $(document).on('click', '.js-stars-wrapper .js-star', function () {
    var value = parseInt($(this).data('value'));

    if (ratingValue == value) {
      value = 0;
    }
    ratingValue = value;

    //$('.rating-stars-wrapper .star').removeClass('full');
    $(this).closest(".js-stars-wrapper").find(".js-star").removeClass('active');
    for (i = 1; i <= value; i++) {
      $('.js-stars-wrapper .js-star[data-value="' + i + '"]').addClass('active');
    }

    $('#rating-stars').val(value);
  });

  $(document).on('change', '.js-accessories input', function () {
    var ids = [];
    $.each($('.js-accessories input:checked'), function (index, element) {
      ids.push(parseInt($(element).val()));
    });
    var data = window.JSON.stringify(ids);
    $('#add-product-form input[name="accessoryIds"]').val(data);
  });

  $(document).on('click', '.show-detail', function (e) {
    $('.nav-tabs a[href="#detail"]').tab('show');
    var divLoc = $('.nav.nav-tabs').offset();
    $('html, body').animate({scrollTop: divLoc.top}, "slow");
  });

    window.onscroll = function (e) {
        // console.log(window.scrollY); // Value of scroll Y in px
        if(window.scrollY > 100){
          $('.js-back-position').addClass('show');
        }
        else{
          $('.js-back-position').removeClass('show');
        }
    };

  var Filter = Filter || {};
  $(document).on('click', '.js-ajax-pagination', function (e) {
    e.preventDefault();
    Frontend.pagination = true;
    $('html, body').animate({
      scrollTop: $(Frontend.options.productListHolderSelector).offset().top - 190
      // scrollTop: $('main').offset().top - 170
    }, 200);

    var productHolder = $('[data-product-holder]');
    Filter.fire       = true;
    loaderActive(productHolder);

    $.nette.ajax({
      url:     $(this).attr('href'),
      success: function ($msg) {
        loaderClose(productHolder);
      }
    });
  });

  /* onclick to hide search form */
  $(document).click(function (event) {
    if (($(".search").length > 0) && ($(".search").hasClass("open"))) {
      if (!$(event.target).closest(".middle .search").length) {
        // console.log('document');
        $(".middle .search").toggleClass("open");
      }
    }
  });
  $('.js-search-close').on('click', function () {
    $(".search").removeClass("open");
  });
  $('.navbar-default .navbar-toggle').on("click", function () {
    $('body').toggleClass("open-menu");
  });


  // ---- kosik - doprava a platba

  // zmena statu v kosiku
  $("body").on("change", ".js-cart-country", function () {

    // zruseni hodnoty u dopravy
    $(".js-cart-transport").prop("checked", false);

    // zruseni hodnoty platby
    $(".js-cart-payment").prop("checked", false);

    $(this).closest('form').submit();
  });

  // zmena dopravy v kosiku -> nacteni plateb
  $("body").on("change", ".js-cart-transport", function () {

    // zruseni hodnoty platby
    $(".js-cart-payment").prop("checked", false);

    $(this).closest('form').submit();


  });

  // zmena platby v kosiku -> prepocet celkove ceny
  $("body").on("change", ".js-cart-payment", function () {

    $(this).closest('form').submit();

  });

  // ---- kosik - informace o objednavajicim

  /**
   * Udalost, ktera nastane pri stisknuti klavesy na inputu
   * @param {type} $e
   * @returns {undefined}
   */
  var $cartIcEvent = function ($e) {

    var $this = $(this);
    var $ic   = $this.val();
    var $len  = $ic.length;

    if ($len < 8) {
      return;
    }

    var $thisClass = $this.attr("class");
    var $url       = $this.data("href");
    var $data      = {ic: $ic};

    /**
     * Metoda se vola po uspesnem provedeni ajaxu
     * @param json $json
     * @returns {undefined}
     */
    var $success = function ($json) {

      if ($json.status === 'ok') {
        var $data = $json.data;

        // predvyplneni policek formulare
        $.each($data, function ($key, $value) {
          $("*[name='" + $key + "']").val($value);
        });

        // zmena barvy ramecku - ok
        $this.css("border-color", "green");

        return;
      }

      //alert($json.message);

      //console.log("IC error: " + $json.message);

      // zmena barvy ramecku - error
      $this.css("border-color", "red");

    };

    /**
     * Metoda se vola po dokonceni ajaxu
     * @returns {undefined}
     */
    var $done = function () {
    };

    // zmena barvy ramecku - processing
    $this.css("border-color", "orange");

    // odeslani nette ajaxu
    $.nette.ajax({
      url:     $url,
      data:    $data,
      success: $success
    }).done($done);

  };

  // odchyceni udalosti
  $("body").on("keyup change blur", ".js-cart-ic", $cartIcEvent);


  // -------------------------------------------------------------------------

  $(".js-login-toggled").slideUp();
  $(document).on("click", ".js-login-toggle", function () {
    $(".js-login-toggled").slideToggle(
      function () {
        // zruseni hodnoty
        //if($(".js-login-toggle").is( ":checked" )){
        if ($(".js-login-toggled").is(":visible")) {
          $(".js-login-toggle").prop("checked", true);
        }
        else {
          $(".js-login-toggle").prop("checked", false);
        }
      }
    );
  });

  $.nette.ext('changePage', {
    before: function (jqXHR, settings) {
      if (Frontend.pagination) {
        window.history.pushState({}, '', settings.url);
      }
    }
  });

  $(window).on('popstate', function (event) {
    if (Frontend.pagination) {
      $.nette.ajax(window.location.href);
      $('html, body').animate({
        scrollTop: $("#" + Frontend.options.productListSnippetName).offset().top - 30
      }, 200);
      Frontend.pagination = false;
    }
  });

    $("body").on("click", ".js-product-list-cart-add", function ($e) {

        var $this     = $(this);
        var $url      = $(this).attr("href");
        var $quantity = $(this).parent().find("input.js-product-list-cart-quantity").val();

        $url = $url.replace("JS_QUANTITY_MACRO", $quantity);

        $.nette.ajax($url).done(function () {


            // ------- POZOR: stejny kod i v sekci Frontend.successAjaxExtensionHandler = function (payload) { ....

            var class_active = 'active';

            //var inst = $(this);
            var modalId = $this.data("target-modal");

            // console.log(modalId);

            $('.modal-block.active').removeClass(class_active);
            $('.modal-overlay').addClass(class_active);
            $('.modal-block[data-target-modal=' + modalId + ']').addClass(class_active);

            $('body').addClass('overflow-hidden');


            // close modal
            $(document).on('click', '.js-close-modal', function () {
                $('.modal-overlay').removeClass(class_active);
                $('.modal-block.active').removeClass(class_active);
                $('body').removeClass('overflow-hidden');
                return false;
            });

            // close modal keypress key escape
            $(document).keydown(function (event) {
                if (event.keyCode == 27 && $('.modal-block').hasClass('active')) {
                    $('.js-close-modal').trigger('click');
                }
            });

            // -----------------------------------------------------------------

        });


        return false;
    });

});

/**
 *  @return void
 */
Frontend.clickSearchSubmitButtonListener = function () {
  $(Frontend.options.searchFormSelector).submit();
};

/**
 *  @return void
 */
Frontend.clickSearchMobileSubmitButtonListener = function () {
  $(Frontend.options.searchMobileFormSelector).submit();
};

/**
 *  @return void
 */
Frontend.initSelect2 = function () {
  $('.js-select').select2({
    minimumResultsForSearch: -1
  });
  $('.js-select-search').select2();
  $('b[role="presentation"]').hide();
};
/**
 *  @return void
 */
Frontend.initSelect2_configurator = function () {
  $('.js-select-configurator').select2({
    minimumResultsForSearch: -1,
    containerCssClass:       'configurator-select',
    dropdownCssClass:        'configurator'
  });
  $('b[role="presentation"]').hide();
};
/**
 *  @return void
 */
Frontend.initSelect2_variants = function () {
  $('.js-select-variants').select2({
    minimumResultsForSearch: -1,
    templateResult:          addIcons,
    templateSelection:       addIcons,
    dropdownCssClass:        'variants'
  });
  $('b[role="presentation"]').hide();
  $('.select2-selection__arrow').append(Frontend.swg);
};

function addIcons (opt) {
  if (!opt.id) {
    return opt.text;
  }

  var optimage = $(opt.element).attr('data-imgsrc');
  var optprice = $(opt.element).attr('data-price');
  var optstock = $(opt.element).attr('data-stock');
  if(optstock == 1){
    var stockIcon = '<i class="fas fa-check in-stock"></i>';
  }
  else{
    var stockIcon = '<i class="fas fa-times out-of-stock"></i>';
  }
  if (optimage) {
    var $opt = $(
        '<span class="select-with-image"><img src="' + optimage + '" class="img-responsive" /><span class="text-wrapper"><span class="name">' + opt.text + '</span><span class="price">' + optprice + '</span><span class="icon">' + stockIcon + '</span></span></span>'
    );
  }
  else {
    var $opt = $('<span>' + opt.text + '</span>');
  }
  return $opt;
}

/**
 * @return void
 */
Frontend.clickedAddProductFormListener = function () {
  $(Frontend.options.addProductFormSelector).submit();
};

/**
 * @return void
 */
Frontend.changeVariantFormListener = function ($this) {
  $('#variant-form-changed').val($this.data('id'));
  $(Frontend.options.variantFormSelector).submit();
};

/**
 *
 * @param jqXHR
 * @param settings
 */
Frontend.beforeAjaxExtensionHandler = function (jqXHR, settings) {
  if (settings.nette !== undefined) {
    Frontend.targetModal = settings.nette.el.data(Frontend.options.targetModalSelector);
  }
};

/**
 *
 * @param payload
 */
Frontend.successAjaxExtensionHandler = function (payload) {
  reservedBtnLoading();

  // konfigurátor - změna url
  window.history.pushState({}, '', $('#configurator-link').data('conf-link'));

  // process snippets
   Frontend.snippetsAjax(payload.snippets);

  //doprava zdarama v header kosiku
  fn_components_offer_calculation_orbinet();

  //zkracovani textu ve vyhledavaci, kosiku... (plugin dotdotdot)
  fn_parts_dots();

  // fn_classic_slider();

  Frontend.initSelect2();
  Frontend.initSelect2_variants();
  Frontend.initSelect2_configurator();
  fn_components_quantity_input();
  if (Frontend.appendProductsFired) {
    $('#' + Frontend.options.productListSnippetName).removeAttr('data-' + Frontend.options.productAjaxAttribute);
  }

  if (Frontend.searchFired) {
    var elm = $(Frontend.options.searchInputSelector);
    elm.focus();
    var val = elm.val();
    elm.val('');
    elm.val(val);
  }

  if (Frontend.searchMobileFired) {
    var elm = $(Frontend.options.searchMobileInputSelector);
    elm.focus();
    var val = elm.val();
    elm.val('');
    elm.val(val);
  }


  // otvirani modalniho okna
  if (Frontend.targetModal) {
    //$(Frontend.targetModal).modal('show');

    var class_active = 'active';

    //var inst = $(this);
    var modalId = Frontend.targetModal;

    // console.log(modalId);
    var modalElement = $('.modal-block[data-target-modal=' + modalId + ']');

    if(modalElement.length) {
      $('.modal-block.active').removeClass(class_active);
      $('.modal-overlay').addClass(class_active);
      modalElement.addClass(class_active);
      $('body').addClass('overflow-hidden');
    }

    // close modal
    $('.js-close-modal').on('click', function () {
      $('.modal-overlay').removeClass(class_active);
      $('.modal-block.active').removeClass(class_active);
      $('body').removeClass('overflow-hidden');
      return false;
    });

    // close modal keypress key escape
    $(document).keydown(function (event) {
      if (event.keyCode == 27 && $('.modal-block').hasClass('active')) {
        $('.js-close-modal').trigger('click');
      }
    });

    // zbyvajici cena do dopravy zdarma "bar"

    var $actualPrice       = parseFloat($('.js-postage-free-price').data('free-price-actual'));
    var $totalPrice        = parseFloat($('.js-postage-free-price').data('free-price-total'));
    var $progressBarStatus = ($actualPrice * 100) / $totalPrice;

    $('.progress-bar-status').animate({width: $progressBarStatus + '%'}, 'slow');

    // ---------------------------------------


    Frontend.targetModal = undefined;
  }

  Frontend.pagination = false;

  //lazy load init
  var modals = document.getElementsByClassName('modal-block');
  initLazyLoad(modals);

  if (Frontend.showParameters) {
    $('.js-product-list-parameters').addClass('show');
  }

  $('.js-detail-buy-button').removeClass('loading');

  if ($('#ajax-history').data('url')) {
    window.history.replaceState({}, '', $('#ajax-history').data('url'));
  }

  initRentalDatePickers();
};

/**
 *
 * @param snippets
 * @return void
 */
Frontend.snippetsAjax = function (snippets) {
  if (snippets === undefined) {
    return;
  }

  $.each(snippets, function (index, el) {

        var element = $(el);
        if (element.find( '.js-gallery' ).length) {
            fn_components_gallery();
        }
        if (element.find( '.js-slider-main-product' ).length) {
            fn_detail_slider();
        }
        if (element.find( '.js-slider-classic' ).length) {
            fn_classic_slider();
        }
        if (element.find( '.js-tabs-group' ).length) {
            fn_components_tabs();
        }

    // if (element.find('.js-accordion-group').length) {
    //   fn_components_accordion();
    // }

  });
};

/**
 *
 * @return void
 */
Frontend.changeSearchInputListener = function () {
  clearTimeout(Frontend.searchTimer);

  Frontend.searchTimer = setTimeout(function () {
    var q = $(Frontend.options.searchInputSelector).val();
    if (Frontend.searchUrl.indexOf('?') > -1) {
      var url = Frontend.searchUrl + '&search-q=' + q;
    } else {
      var url = Frontend.searchUrl + '/?search-q=' + q;
    }

    $.nette.ajax(url);

  }, Frontend.options.searchDelay);
};

/**
 *
 * @return void
 */
Frontend.changeSearchMobileInputListener = function () {
  clearTimeout(Frontend.searchMobileTimer);

  Frontend.searchMobileTimer = setTimeout(function () {
    var q = $(Frontend.options.searchMobileInputSelector).val();
    if (Frontend.searchMobileUrl.indexOf('?') > -1) {
      var url = Frontend.searchMobileUrl + '&searchMobile-q=' + q;
    } else {
      var url = Frontend.searchMobileUrl + '/?searchMobile-q=' + q;
    }

    $.nette.ajax(url);

  }, Frontend.options.searchMobileDelay);
};

/* ==========================================================================
 *  Function: Offer calculation
 * ======================================================================= */
function fn_components_offer_calculation_orbinet () {
  if ($('.js-progress-bar-status').length) {
    $this           = $('.js-progress-bar-status');
    var actualPrice = $this.data('free-price-actual');
    var totalPrice  = $this.data('free-price-total');

    // console.log(actualPrice);
    // console.log(totalPrice);

    var missingPrice = totalPrice - actualPrice;

    $('.js-postage-wrapper').find('.js-free-price-missing').text(missingPrice);

    var progressBarStatus = (actualPrice * 100) / totalPrice;

    // $( '#progress-bar-status' ).css('width', progressBarStatus + '%');

    $this.closest('.progress-bar-status').animate({width: progressBarStatus + '%'}, 'slow');
  }
}

function dropdownMenuHover () {
  if ($(window).width() > 769) {
    $('body').on('mouseenter mouseleave', '.dropdown-toggle', function (e) {
      var dropdown = $(e.target).closest('.dropdown');
      var menu     = $('.dropdown-menu', dropdown);
      dropdown.addClass('show');
      menu.addClass('show');
      setTimeout(function () {
        dropdown[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
        menu[dropdown.is(':hover') ? 'addClass' : 'removeClass']('show');
      }, 300);
    });
    $('body').on('mouseleave', '.dropdown', function (e) {
      var dropdown = $(e.target).closest('.dropdown');
      var menu     = $('.dropdown-menu', dropdown);
      setTimeout(function () {
        dropdown[dropdown.is(':hover') ? '' : 'removeClass']('show');
        menu[dropdown.is(':hover') ? '' : 'removeClass']('show');
      }, 300);
    });
  }
}

var instagramFeed = new Instafeed({
  get:         'user',
  target:      'instagramfeed',
  userId:      '7904542852',
  clientId:    '4a4b635627c341019a2aa61a3aa0157b',
  accessToken: '7904542852.4a4b635.301e0f6487344bc780c682272d24e4d6',
  resolution:  'standard_resolution',
  template:    '<div><a href="{{link}}" target="_blank"><img src="{{image}}" /></a></div>',
  limit:       '24',
  after:       function () {
    $('.multiple-item').slick({
      infinite:       true,
      slidesToShow:   4,
      slidesToScroll: 2,
      responsive:     [
        {
          breakpoint: 1440,
          settings:   {
            slidesToShow:   4,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1200,
          settings:   {
            slidesToShow:   4,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 992,
          settings:   {
            slidesToShow:   3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 576,
          settings:   {
            slidesToShow:   2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 370,
          settings:   {
            slidesToShow:   1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
});

// function initLazyLoad() {
//     console.log('laaaazy');
//     [].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
//         img.setAttribute('src', img.getAttribute('data-src'));
//         img.onload = function () {
//             img.removeAttribute('data-src');
//         };
//     });
// }

function initLazyLoad(modals) {
    var $q = function(q, res){
            if (document.querySelectorAll) {
                res = document.querySelectorAll(q);
            } else {
                var d=document
                    , a=d.styleSheets[0] || d.createStyleSheet();
                a.addRule(q,'f:b');
                for(var l=d.all,b=0,c=[],f=l.length;b<f;b++)
                    l[b].currentStyle.f && c.push(l[b]);

                a.removeRule(0);
                res = c;
            }
            return res;
        }
        , addEventListener = function(evt, fn){
            window.addEventListener
                ? this.addEventListener(evt, fn, false)
                : (window.attachEvent)
                ? this.attachEvent('on' + evt, fn)
                : this['on' + evt] = fn;
        }
        , _has = function(obj, key) {
            return Object.prototype.hasOwnProperty.call(obj, key);
        }
    ;

    function loadImage (el, fn) {
        var img = new Image()
            , src = el.getAttribute('data-src');
        img.onload = function() {
            if (!! el.parent)
                el.parent.replaceChild(img, el)
            else
                el.src = src;

            fn? fn() : null;
        }
        img.src = src;
    }

    function elementInViewport(el) {
        var rect = el.getBoundingClientRect()

        return (
            rect.top    >= 0
            && rect.left   >= 0
            && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        )
    }

    var images = new Array()
        , query = $q('img.lazy')
        , processScroll = function(){
            for (var i = 0; i < images.length; i++) {
                if (elementInViewport(images[i])) {
                    loadImage(images[i], function () {
                        images.splice(i, i);
                    });
                }
            };
        }
    ;
    // Array.prototype.slice.call is not callable under our lovely IE8
    for (var i = 0; i < query.length; i++) {
        images.push(query[i]);
    };

  if (modals && modals.length) {
    for (var i = 0; i < modals.length; i++) {
      modals[i].addEventListener('scroll', function () {
        processScroll()
      });
    }
  }

    processScroll();
    window.addEventListener('scroll',processScroll);

};

function fn_advantage_slider () {
    if ($('.js-slider-advantage').length) {
        $('.js-slider-advantage').slick({
            infinite:       true,
            slidesToShow:   6,
            slidesToScroll: 1,
            swipeToSlide: true,
            mobileFirst: true,
            responsive:     [
                {
                    breakpoint: 250,
                    settings:   {
                        slidesToShow:   1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 370,
                    settings:   {
                        slidesToShow:   1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 575,
                    settings:   {
                        slidesToShow:   2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 770,
                    settings:   {
                        slidesToShow:   3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings:   {
                        slidesToShow:   4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1220,
                    settings:   {
                        slidesToShow:   5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1439,
                    settings:   {
                        slidesToShow:   6,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}
function fn_category_slider () {
    if ($('.js-slider-category').length) {
        $('.js-slider-category').slick({
            infinite:       true,
            slidesToShow:   4,
            slidesToScroll: 1,
            swipeToSlide: true,
            mobileFirst: true,
            responsive:     [
                {
                    breakpoint: 250,
                    settings:   {
                        slidesToShow:   1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 370,
                    settings:   {
                        slidesToShow:   1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 575,
                    settings:   {
                        slidesToShow:   2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 770,
                    settings:   {
                        slidesToShow:   3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings:   {
                        slidesToShow:   3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1220,
                    settings:   {
                        slidesToShow:   4,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}

function GetIEVersion() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0)
    return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./))
    return 11;

  else
    return 0; //It is not IE
}

if (GetIEVersion() > 0){
  // alert("This is IE " + GetIEVersion());
  if(GetIEVersion() == 11){
    // $('.dots').addClass('ie-dots');
  }
}

function reservedBtnLoading(){
  var elementBtn = document.getElementById("js-detail-buy-button");
  if(elementBtn !== undefined && elementBtn !== null) {
      elementBtn.addEventListener("click", function () {
      elementBtn.classList.add("loading");
    });
  }
}

$(document).on('click', '.js-redirect-on-click', function (a) {
  var $target = $(a.target);
  var redirectTo = $target.data('redirect-to');

  if(redirectTo){
    window.location.href = redirectTo;
  }
});